import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange, Output, EventEmitter } from '@angular/core';
import { IFaresContentModel } from '../fares.interfaces';

@Component({
    selector: 'sbw-change-tiers-warning',
    templateUrl: './change-tiers-warning.component.html'
})
export class ChangeTiersWarningComponent implements OnInit, OnChanges {
    @Input() outProductCode: string
    @Input() returnProductCode: string
    @Input() content: IFaresContentModel

    @Output() changeTiers = new EventEmitter<IChangeTiers>()
    private active = false
    private shown = false
    public showPopup = false

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.active) return
        if (!this.outProductCode || !this.returnProductCode || this.outProductCode.toUpperCase() != this.returnProductCode.toUpperCase()) {
            if (!this.shown) this.shown = this.showPopup = true
            this.changeTiers.emit({
                outProductCode: changes.returnProductCode && this.returnProductCode,
                returnProductCode: changes.outProductCode && this.outProductCode
            })
        }
    }

    constructor() { }

    ngOnInit() {
        this.active = this.returnProductCode != null
    }

    ensureRealChange(change: SimpleChange): SimpleChange {
        return change && change.previousValue && change.currentValue.toUpperCase() != change.previousValue.toUpperCase() ? change : null
    }

}

export interface IChangeTiers {
    outProductCode?: string,
    returnProductCode?: string,
}
